


















































import { Component, Vue, Emit } from "vue-property-decorator";
import locationService, { LocationService } from "../services/LocationService";
import moment from 'moment';
var _ = require("underscore")._;

@Component
export default class Location extends Vue {
  private currentPage: number = 1;
  private locations: any = { records: [], totalRecords: 0 };
  private search: any = "";
  private status: any = [
    { text: "Active", value: "A" },
    { text: "Inactive", value: "I" }
  ];
  private locationFields: any = [
    {
      key: "id",
      label: "No",
      thStyle: {
        width: "80px"
      }
    },
    {
      key: "name",
      label: "Name"
    },
    {
      key: "location",
      label: "Location"
    },
    {
      key: "status",
      label: "Status"
    },
    {
      key: "updatedDate",
      label: "Last Update"
    },
    {
      key: "actions",
      label: " ",
      thStyle: {
        width: "80px"
      }
    }
  ];

  created() {
    this.getLocations();
  }

  filteredList() {
    let list = this.locations.records.filter((c: any) => {
      const name = c.name.toLowerCase().includes(this.search.toLowerCase());
      return name;
    });
    this.locations.totalRecords = list.length;
    return list;
  }

  formatdate(dateTiem: any) {
    if (dateTiem) {
      return moment(String(dateTiem)).format('DD/MM/YYYY hh:mm:ss');
    }
  }

  showStatus(status: any) {
    return _.findWhere(this.status, { value: status }).text;
  }

  getLocations() {
    locationService.getLocations().then((response: any) => {
      this.locations.records = response.data;
      this.locations.totalRecords = response.data.length;
    });
  }

  @Emit()
  deleteLocationConfirm(event: Event, id: number) {
    event.preventDefault();
    this.$swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then(result => {
      if (result.value) {
        this.deleteLocation(id);
      }
    });
  }

  deleteLocation(id: number) {
    this.$swal({
      title: "Waiting",
      timer: 10000,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        this.$swal.showLoading();
      }
    });

    locationService
      .deleteLocation(id)
      .then((response: any) => {
        this.getLocations();
        this.$swal({
          confirmButtonColor: "#28a745",
          title: "Complete",
          type: "success"
        });
      })
      .catch((error: any) => {
        this.$swal({
          title: "Please try again!",
          type: "error"
        });
      });
  }
}
